/*
  Links naar WhatsApp (wa.me) openen via de WhatsApp-widget (app "WP Button"),
  zodat de klik net zo werkt en geregistreerd wordt als op het groene bolletje.
  Is de widget (nog) niet geladen, dan werkt de gewone wa.me-link.
*/
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href*="wa.me/"]');
  if (!link || link.closest('#wfb-widget-container')) return;

  const widgetButton = document.querySelector('#wfb-widget-container .wfb-platform-btn[data-platform="whatsapp"]');
  if (!widgetButton) return;

  event.preventDefault();
  widgetButton.click();
});
